import Vue from "vue";
import VueRouter from "vue-router";
import App from "./App.vue";
import router from "./router";
//Plugins
import VueTooltip from "v-tooltip";
import "@fortawesome/fontawesome-free";
import "@fortawesome/fontawesome-free/css/all.css";
import vuetify from '@/plugins/vuetify' // path to vuetify export 
import '@mdi/font/css/materialdesignicons.css';
import './scss/styles.scss'; // Ruta al archivo de estilos globales
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.min";
import { store } from "./Aplicaciones/Masters/Store/store.js";
import Hotjar from 'vue-hotjar';
//Componentes
import { VTooltip, VPopover, VClosePopover } from "v-tooltip";
import VueSimpleAlert from "vue-simple-alert";
import EtiquetaCampo from "./Aplicaciones/Masters/Componentes/EtiquetaCampo.vue";
//Mixins globales
import mixinGlobal from "./mixins/serviciosGlobales";
// Otros servicios
import { iniciarSeguimientoInactividad } from "./Aplicaciones/Masters/servicios/servicioInactividad.js";

Vue.directive("tooltip", VTooltip);
Vue.use(VueSimpleAlert);
Vue.use(Hotjar,{
  id: '2773807',
  isProduction: process.env.VUE_APP_ENTORNO == 'produccion' ? true : false
});
Vue.directive("close-popover", VClosePopover);
Vue.component("v-popover", VPopover);
Vue.component("EtiquetaCampo", EtiquetaCampo);
VTooltip.options.defaultHtml = false;
Vue.use(VueTooltip);
VueTooltip.options.defaultTemplate =
  '<div class="tooltip-vue" role="tooltip"><div class="tooltip-vue-arrow"></div><div class="tooltip-vue-inner"></div></div>';
VueTooltip.options.defaultArrowSelector =
  ".tooltip-vue-arrow, .tooltip-vue__arrow";
VueTooltip.options.defaultInnerSelector =
  ".tooltip-vue-inner, .tooltip-vue__inner";
VueTooltip.options.defaultTrigger = "hover focus click";
Vue.config.productionTip = false;
iniciarSeguimientoInactividad();
Vue.use(VueRouter);
Vue.mixin(mixinGlobal);

new Vue({
  store,
  router,
  vuetify,
  render: h => h(App)
}).$mount("#app");
